import type { ChangelogEntry } from "../types";

/**
 * Lead-poolen: en daglig kjøring finner kalde leads med verifisert direktenummer
 * over hele landet og legger dem i listen «Lead-kurator».
 */
export const LEAD_POOL_2026_10: ChangelogEntry = {
  id: "2026-10-27-lead-pool",
  date: "2026-10-27",
  title: "Leads-poolen fylles automatisk med kalde leads",
  summary: "En daglig kjøring legger nye leads med verifisert direktenummer i listen «Lead-kurator».",
  sections: [
    {
      heading: "Leads",
      items: [
        {
          title: "Nye leads hver morgen, og påfyll når poolen går tom",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Hver morgen fylles listen «Lead-kurator» opp med aksjeselskap fra hele landet som omsetter for 30 til 1000 millioner kroner og går med overskudd. Hvert lead har daglig leder eller markedsansvarlig med eget nummer fra selskapets nettside, og en kort begrunnelse for hvorfor selskapet passer. Eksisterende kunder kommer aldri i poolen. Faller poolen under grensen i løpet av dagen, startes et nytt påfyll. Kjøringen kan pauses og har et månedstak under Salgsmuligheter, Agenter.",
        },
      ],
    },
  ],
};
